module.exports = __webpack_public_path__ + "static/media/confetti-mobile.916e2784.svg";